export const HMS_IFRAME_MESSAGES = {
  authToken: "HMS_AUTH_TOKEN",
  ready: "PROCEDURE_READY",
  authRequest: "PROCEDURE_AUTH_REQUEST",
  close: "PROCEDURE_CLOSE",
  navigate: "PROCEDURE_NAVIGATE",
};
